import React, { useState } from "react";
import RegisterFormHeader from "./header/RegisterFormHeader";
import RegisterFormStep from "./step/RegisterFormStep";
import { FORM_ERROR } from "final-form";
import { Form as FinalForm, Field } from "react-final-form";
import { registerValidation } from "../../../../app/store/actions/registerActions";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthLessThan,
  hasLengthBetween,
  // hasLengthGreaterThan,
} from "revalidate";
import { isValidEmail } from "../../../../app/util/revalidateUtils";
import { Form, Button, Grid, GridColumn, Header } from "semantic-ui-react";
import TextInput from "../../../../app/common/form/TextInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import DateInput from "../../../../app/common/form/DateInput";
import { connect } from "react-redux";
import RegisterCancel from "./RegisterCancel";
import {
  CODIGO_TIPO_DOCUMENTO_CCEE,
  CODIGO_TIPO_DOCUMENTO_DNI,
  LONGITUD_MAXIMA_CELULAR,
  // LONGITUD_MAXIMA_CUENTA_CREDITO,
  LONGITUD_MAXIMA_CORREO,
  // LONGITUD_MINIMA_CUENTA_CREDITO,
} from "../../../../app/infrastructure/appConstants";
import { normalizeNumero } from "../../../../app/util/finalFormUtils";
import RegisterRecover from "./RegisterRecover";
import PropTypes from "prop-types";
import RegistroDigitalAppMessage from "../../../../app/common/messages/RegistroDigitalAppMessage";

const mapState = (state) => ({
  currentCustomer: state.registerUser.currentCustomer,
});

const actions = {
  registerValidation,
};

const validate = combineValidators({
  fechaNacimiento: composeValidators(
    isRequired({ message: "Fecha de nacimiento es requerido" })
  )(),
  celular: composeValidators(
    isRequired({ message: "Celular es requerido" }),
    hasLengthBetween(
      LONGITUD_MAXIMA_CELULAR,
      LONGITUD_MAXIMA_CELULAR
    )({
      message: "Celular no válido",
    })
  )(),
  correoElectronico: composeValidators(
    isRequired({ message: "Correo electrónico es requerido" }),
    isValidEmail,
    hasLengthLessThan(LONGITUD_MAXIMA_CORREO + 1)({
      message: "Correo electrónico no válido",
    })
  )(),
  // numeroCuentaCredito: composeValidators(
  //   isRequired({ message: "Número de cuenta o crédito es requerido" }),
  //   hasLengthGreaterThan(LONGITUD_MINIMA_CUENTA_CREDITO)({
  //     message: "Ingresa al menos 10 dígitos",
  //   })
  // )(),
});

const PARAMETER_VALIDATE_CORREO = "Correo";
const PARAMETER_VALIDATE_CELULAR = "celular";

const RegisterValidationForm = ({ currentCustomer, registerValidation }) => {
  //states
  const [
    showMessageRegistroDigitalApp,
    setMessageRegistroDigitalApp,
  ] = useState(false);
  return (
    <FinalForm
      onSubmit={(values) =>
        registerValidation({ ...currentCustomer, ...values }).catch((error) => {
          //Solo aplica para DNI o CE
          if (
            (currentCustomer.tipoDocumentoCliente ===
              CODIGO_TIPO_DOCUMENTO_DNI ||
              currentCustomer.tipoDocumentoCliente ===
                CODIGO_TIPO_DOCUMENTO_CCEE) &&
            error.data.message &&
            (error.data.message.includes(PARAMETER_VALIDATE_CORREO) ||
              error.data.message.includes(PARAMETER_VALIDATE_CELULAR))
          ) {
            setMessageRegistroDigitalApp(true);
          } else {
            return {
              [FORM_ERROR]: error,
            };
          }
        })
      }
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit,
      }) => (
        <Form onSubmit={handleSubmit} error>
          <br />
          <RegisterFormHeader />
          <RegisterFormStep />
          <Header textAlign="center">
            <Header.Subheader>
              Ingresa los siguientes datos para validar que eres tú
            </Header.Subheader>
          </Header>
          <br />
          <Field
            name="fechaNacimiento"
            component={DateInput}
            placeholder="Fecha de nacimiento"
          />

          <Field
            name="correoElectronico"
            component={TextInput}
            placeholder="Correo electrónico"
            maxLength={LONGITUD_MAXIMA_CORREO}
          />

          <Field
            name="celular"
            component={TextInput}
            placeholder="Celular"
            maxLength={LONGITUD_MAXIMA_CELULAR}
            parse={normalizeNumero}
          />

          {/* <Field
            name="numeroCuentaCredito"
            component={TextInput}
            placeholder="Número de cuenta o crédito en Prymera"
            maxLength={LONGITUD_MAXIMA_CUENTA_CREDITO}
            parse={normalizeNumero}
          /> */}

          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage error={submitError} />
          )}
          <br />
          {showMessageRegistroDigitalApp && (
            <>
              <RegistroDigitalAppMessage /> <br />
            </>
          )}

          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <GridColumn>
                <RegisterCancel />
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  size="large"
                  loading={submitting}
                  color="yellow"
                  content="Aceptar"
                />
              </GridColumn>
            </Grid.Row>
          </Grid>

          <br />
        </Form>
      )}
    />
  );
};

RegisterValidationForm.propTypes = {
  currentCustomer: PropTypes.object.isRequired,
  registerValidation: PropTypes.func.isRequired,
};

export default connect(mapState, actions)(RegisterValidationForm);
